<template>
  <div class="pagination">
    <!--<span :class="{disabled: curPage == 1}" @click="prevPage" v-if="pageCount > 1">上一页</span>-->
    <span :class="{active: curPage == 1}" @click="page(1)">1</span>
    <span v-show="curPage > 5 && pageCount > 10">...</span>
    <span :class="{active: curPage == index+offset}" v-for="(item,index) in middlePages" @click="page(index+offset)">{{index+offset}}</span>
    <span v-show="curPage < bigLimit && pageCount > 10">...</span>
    <span :class="{active: curPage == pageCount}" @click="page(pageCount)" v-if="pageCount > 1">{{pageCount}}</span>
    <!--<span :class="{disabled: curPage == pageCount}" @click="nextPage" v-if="pageCount > 1">下一页</span>-->
  </div>
</template>

<script>
  export default {
    name: "Pagination",
    props: {
      pageCount: {
        // type: number,
        default: 0
      }
    },
    data () {
      return {
        bigLimit: 5,
        curPage: 1,
        index: 1,
        offset: 0,
        middlePages: [{
          item: "",
          index: 0
        }]
      }

    },
    methods: {
      page (curPage) {

      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pagination.vue